import React from 'react';
import { useMarketplace } from '../../contexts/MarketplaceContext';
import { travelCost } from '../../utils/event';
import { performerFit } from '../../utils/fit';
import { baht } from '../../utils/format';
import type { MusicEvent, Performer } from '../../types/marketplace';
interface CompareTableProps {
  event: MusicEvent;
  performers: Performer[];
}
export function CompareTable({
  event,
  performers
}: CompareTableProps) {
  const {
    organiserPrefs
  } = useMarketplace();
  if (performers.length < 2) return null;
  const rows: {
    label: string;
    value: (p: Performer) => string;
    best?: (p: Performer) => number;
  }[] = [{
    label: 'Act',
    value: p => p.members > 1 ? `${p.actType} · ${p.members}` : p.actType
  }, {
    label: 'Fee',
    value: p => baht(p.price),
    best: p => -p.price
  }, {
    label: 'Travel',
    value: p => baht(travelCost(p, p.distanceKm)),
    best: p => -travelCost(p, p.distanceKm)
  }, {
    label: 'Rating',
    value: p => `${p.rating.toFixed(1)} (${p.reviewCount})`,
    best: p => p.rating
  }, {
    label: 'Fit',
    value: p => `${performerFit(p, event, organiserPrefs).score}%`,
    best: p => performerFit(p, event, organiserPrefs).score
  }];
  return <section aria-labelledby="compare-title" className="mt-10" data-id="element-466" data-mp="164oi9trv1g4h">
      <h2 id="compare-title" className="text-lg font-bold" data-id="element-467" data-mp="162bqkowavre8">
        Compare your matches
      </h2>
      <p className="text-sm text-ink-3" data-id="element-468" data-mp="1ax7v2oiq4788">Best value in each row is highlighted.</p>
      <div className="no-scrollbar mt-4 overflow-x-auto" data-id="element-469" data-mp="1ftpv5b33zhe8">
        <table className="w-full min-w-[520px] border-collapse text-left text-[15px]" data-id="element-470" data-mp="1kst1qzyqlvob">
          <thead data-id="element-471" data-mp="1ov5xqwnomf7w">
            <tr data-id="element-472" data-mp="1ouo50a08aj4q">
              <th className="w-28 py-3" scope="col" data-id="element-473" data-mp="1ow7jbv2bqk3v">
                <span className="sr-only" data-id="element-474" data-mp="1tu0s8vv0hs7u">Attribute</span>
              </th>
              {performers.map(p => <th key={p.id} scope="col" className="py-3 pr-4 align-bottom" data-id="element-475" data-mp="3qmspj0feee5f">
                  <span className="flex items-center gap-2" data-id="element-476" data-mp="3vldpqzungxtv">
                    <img src={p.photos[0]} alt="" className="h-8 w-8 rounded-full object-cover" data-id="element-477" data-mp="3vlm6x3xt2pav" />
                    <span className="truncate font-bold" data-id="element-478" data-mp="12r5hy35b8ef8">{p.name}</span>
                  </span>
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-479" data-mp="1brtuetf226q0">
            {rows.map(row => {
            const top = row.best ? Math.max(...performers.map(row.best)) : null;
            return <tr key={row.label} className="border-t border-line" data-id="element-480" data-mp="16utmse2k4vws">
                  <th scope="row" className="py-3 text-sm font-semibold text-ink-3" data-id="element-481" data-mp="1lnwxq2ln8bej">
                    {row.label}
                  </th>
                  {performers.map(p => {
                const isBest = row.best && row.best(p) === top;
                return <td key={p.id} className="tabular py-3 pr-4" data-id="element-482" data-mp="1qhrd4tu7u47t">
                        <span className={isBest ? 'rounded-full bg-tint px-2 py-0.5 font-bold text-brand-strong' : 'font-semibold'} data-id="element-483" data-mp="24fprhz8je0nb">{row.value(p)}</span>
                      </td>;
              })}
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </section>;
}